import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import Nav from '../../components/Nav';
import Footer from '../../components/Footer';
import { SearchBar } from '../../components/SearchBar';
import { Source } from '../../components/Source';
import { WordDefinition } from '../../components/WordDefinition';
import { WordMeaning } from '../../components/WordMeaning';
import { SearchContext, SearchContextType } from '../../contexts/SearchContext';
import { ThemeContext, ThemeContextType } from '../../contexts/ThemeContext';
import useSearch from '../../hooks/useSearch';

export default function Home() {
	const [word, setWord] = useState('');
	const [response, loading] = useSearch(word);

	const [searchParams] = useSearchParams();
	const searchQuery = searchParams.get('search');

  const [theme, setTheme] = useState<string>(() => localStorage.getItem('theme') || 'light');
  const [font, setFont] = useState<string>(() => localStorage.getItem('font') || 'font-inter');

  const themeValue: ThemeContextType = { theme, setTheme, font, setFont };
  const searchContext: SearchContextType = { word, setWord, response, setResponse: () => {}, isLoading: loading };

	useEffect(() => {
		if (searchQuery) {
			setWord(searchQuery);
		}
	}, [searchQuery]);

  useEffect(() => localStorage.setItem('theme', theme), [theme]);

	return (
		<ThemeContext.Provider value={themeValue}>
			<SearchContext.Provider value={searchContext} >
				<div className={`${theme === "dark" && "dark"} ${font}`}>
          <div className="dark:bg-dark-400 dark:text-white h-full min-h-screen">
            <div className="px-5 pt-4 max-w-2xl mx-auto">
              <Nav />
              <SearchBar />
              <WordDefinition />
              {response?.meanings?.map((meaning, index) => (
                <WordMeaning key={index} meaning={meaning} />
              ))}
              {response?.sourceUrls && <Source sourceUrls={response.sourceUrls} />}
              <Footer />
            </div>
          </div>
        </div>
			</SearchContext.Provider>
		</ThemeContext.Provider>
	);
}
